import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import PresentationTab from './PresentationTab';
import LocationTab from './LocationTab';
import FeaturesTab from './FeaturesTab';
import AmenitiesTab from './AmenitiesTab';
import PicturesTab from './PicturesTab';
import CheckInOutTab from './CheckInOutTab';
import CancellationPolicyTab from './CancellationPolicyTab';

const PropertyEditor = (props) => {
  return (
    <div>
      <Tabs defaultActiveKey={1} id="property-form">
        <Tab eventKey={1} title="Presentation">
          <PresentationTab
            objectData={ props.objectData }
            onChange={ props.onChangePresentation || props.onChange }
            availableLocales={ props.availableLanguages }
          />
        </Tab>
        <Tab eventKey={2} title="Location">
          <LocationTab
            objectData={ props.objectData }
            findZones={ props.findZones }
            findAreas={ props.findAreas }
            countries={ props.countries }
            zones={ props.zones }
            areas={ props.areas }
            onChange={ props.onChangeLocation || props.onChange }
            onChangeAreasSelector={ props.onChangeAreasSelector || props.onChange }
            availableLocales={ props.availableLanguages }
            defaultLanguage={ props.defaultLanguage }
          />
        </Tab>
        <Tab eventKey={3} title="Features">
          <FeaturesTab
            objectData={ props.objectData }
            onChange={ props.onChangeFeatures || props.onChange }
          />
        </Tab>
        <Tab eventKey={4} title="Amenities">
          <AmenitiesTab
            objectData={ props.objectData }
            amenities={ props.amenities }
            onChange={ props.onChangeFeatures || props.onChange }
            defaultLanguage={ props.defaultLanguage }
          />
        </Tab>
        <Tab eventKey={5} title="Pictures">
          <PicturesTab
            objectData={ props.objectData }
            pictures={ props.objectData.pictures || [] }
            onChange={ props.onChangePictures || props.onChange }
            onSavePicture={ props.onSavePicture }
            onSavePicturesOrder={ props.onSavePicturesOrder }
            pictureUrl={ props.pictureUrl }
            availableLocales={ props.availableLanguages }
            defaultLanguage={ props.defaultLanguage }
            savedPicture={ props.savedPicture }
            uploadingPicture={ props.uploadingPicture }
            uploadSuccess={ props.uploadSuccess }
            onDeletePicture={ props.onDeletePicture }
            onDeletePictureSuccess={ props.onDeletePictureSuccess }
            deletingPicture={ props.deletingPicture }
            deletePictureSuccess={ props.deletePictureSuccess }
          />
        </Tab>
        <Tab eventKey={6} title="Check in/out">
          <fieldset>
            <CheckInOutTab
              objectData={ props.objectData.check_in_out_ruleset || {} }
              onChange={ props.onChangeFeatures || props.onChange }
            />
          </fieldset>
        </Tab>
        <Tab eventKey={7} title="Cancellation policy">
          <fieldset>
            <CancellationPolicyTab
              objectData={ props.objectData.cancellation_policy || {} }
              onChange={ props.onChangeFeatures || props.onChange }
            />
          </fieldset>
        </Tab>
      </Tabs>
    </div>
  );
};

export default PropertyEditor;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/PropertyEditor.jsx